import React, { useContext } from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo.jpg";
import { MyContext } from "../../App";

// Icons
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import HeadphonesOutlinedIcon from "@mui/icons-material/HeadphonesOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";

const Footer = () => {
  const context = useContext(MyContext);

  return (
    <footer className="footerWrapper">
      <div className="container-fluid">
        <div className="row footerTop">

          {/* Brand Info */}
          <div className="col-md-3 footerBrand">
            <Link to="/">
              <img src={Logo} alt="Paymond" className="footerLogo" />
            </Link>

            <p className="mt-3">
              Paymond – India’s trusted online shopping destination.
            </p>

            <ul className="footerContact">
              <li>
                <LocationOnOutlinedIcon />
                First Floor Sh 52 Madhubani Benipatti Road Arer near SBI Bank Madhubani Bihar 847223
              </li>
              <li>
                <HeadphonesOutlinedIcon />
                +91 9942265212
              </li>
              <li>
                <EmailOutlinedIcon />
                paymondtechnologies@gmail.com
              </li>
              <li>
                <WatchLaterOutlinedIcon />
                Mon – Sat | 10:00 AM – 6:00 PM
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div className="col footerLinks">
            <h4>Customer Service</h4>
            <ul>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/support">Support Center</Link></li>
              <li><Link to="/shipping-policy">Shipping Policy</Link></li>
              <li><Link to="/return-and-refund">Return & Refund</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="col footerLinks">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/my-account">My Account</Link></li>
              <li><Link to="/orders">My Orders</Link></li>
              <li><Link to="/myList">Wishlist</Link></li>
              <li><Link to="/">Home</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="col footerLinks">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/data-retention-policy">Data Retention Policy</Link></li>
              <li><Link to="/cookie-policy">Cookie Policy</Link></li>
              <li><Link to="/disclaimer">Disclaimer</Link></li>
            </ul>
          </div>
        </div>

        <hr />

        {/* Bottom Strip */}
        <div className="row footerBottom align-items-center">
          <div className="col-md-6">
            <p className="mb-0">
              © 2026 Paymond Services Private Limited. All rights reserved.
            </p>
          </div>

          <div className="col-md-6 text-end">
            <ul className="socialIcons">
              <li><Link to="#"><FacebookOutlinedIcon /></Link></li>
              <li><Link to="#"><TwitterIcon /></Link></li>
              <li><Link to="#"><InstagramIcon /></Link></li>
              <li><Link to="#"><YouTubeIcon /></Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
